<template>
  <search
    :create-route="createRoute"
    :can-create="canCreate"
    :search-route="searchRoute"
    :page-title="pageTitle"
    :search-filter="searchFilter"
    :place-holder="placeHolder"
    :excluded-fields="['status']"
    :model-name="modelName"
    :is-subscribed="isSubscribed"
  >
    <template slot="results" slot-scope="{ items }">
      <div class="py-12 space-y-12">
        <div class="bg-white rounded-lg">
        <article
          v-for="(news) in items"
          :key="news.id"
          class="flex flex-col items-start justify-between max-w-3xl p-4"
        >
          <div class="flex items-center text-sm gap-x-4">
            <time datetime="2020-03-16" class="text-gray-500">{{ news.posted_at }}</time>
          </div>

          <div class="relative group">
            <h3 class="mt-1 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
              <a :href="news.route">
                <span class="absolute inset-0"></span>
                <p v-html="news.headline"></p>
              </a>
            </h3>

            <p class="mt-4 text-sm leading-6 text-gray-600 line-clamp-3">{{ news.summary }}</p>
          </div>
        </article>
        </div>
      </div>
    </template>
  </search>
</template>

<script>
export default {
   props: {
    createRoute: {
      type: String,
      required: false,
      default: null
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    searchFilter: {
      type: [Array, Object],
      required: false,
    },
    placeHolder: {
      type: String,
    },
    modelName: {
      type: String,
    },
    isSubscribed: {
      type: Boolean,
      required: false,
    }
  },
};
</script>
